import { Component, ElementRef, ViewChild, inject } from '@angular/core';

import { LoginComponent } from '../../login.component';

@Component({
  selector: 'app-login-mobile-credentials-step',
  templateUrl: './login-mobile-credentials-step.component.html',
  styleUrls: ['../../shared-styles/login-device-view.component.scss', './login-mobile-credentials-step.component.scss'],
  standalone: false,
})
export class LoginMobileCredentialsStepComponent {
  public readonly login = inject(LoginComponent);

  @ViewChild('emailInput') private emailInput?: ElementRef<HTMLInputElement>;
  @ViewChild('passwordInput') private passwordInput?: ElementRef<HTMLInputElement>;

  public focusCredentialInput(field: 'email' | 'password'): void {
    const input = field === 'email' ? this.emailInput?.nativeElement : this.passwordInput?.nativeElement;

    if (!input) {
      return;
    }

    input.focus();
    input.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
}
